import React, { useRef } from 'react';
import Section from '../../../shared/Section/Section';
import Accordions from '../../../shared/Accordions/Accordions';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';

const SummaryComponent = ({ title, image }) => {
  const isUpperLg = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      gap={2}
      sx={{ width: '100%', ml: 1, my: 0.5 }}
    >
      {image && isUpperLg && (
        <GatsbyImage
          style={{ width: 130 }}
          imgStyle={{ height: 'fit-content' }}
          image={image}
          alt="reason_of_study"
          loading="lazy"
        />
      )}
      <Typography variant="desktopH5" color={'kit.text.h'}>
        {title}
      </Typography>
    </Box>
  );
};
export default function ReviewsWrapper({
  title,
  image,
  ymEvent,
  images,
  children,
}) {
  const ymEventsRef = useRef({});
  const clickHandler = (ymEvent) => {
    if (!(ymEvent in ymEventsRef.current)) {
      sendYandexMetrikaEvent(ymEvent);
      ymEventsRef.current[ymEvent] = true;
    }
  };
  return (
    <Section withoutBg>
      <Accordions
        onClick={() => clickHandler(ymEvent)}
        sx={(theme) => ({
          '& .MuiButtonBase-root.MuiAccordionSummary-root': {
            paddingRight: { xs: '28px', md: '48px' },
            paddingLeft: { xs: 1.5, md: 3 },
          },
          borderRadius: 6,
          [theme.breakpoints.down('sm')]: {
            borderRadius: 0,
            mx: -2,
          },
        })}
        details={children}
        summary={
          <SummaryComponent title={title} image={getImage(images[image])} />
        }
      />
    </Section>
  );
}
